// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading__EuLKO","specificity":"style__specificity__i5VkT","buttonContainer":"style__buttonContainer__w15rE","backBtn":"style__backBtn__FzSIY"};